module.exports = __webpack_public_path__ + "static/media/cs-roof.5d8df2d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/cs-roof.jpg
// module id = 873
// module chunks = 1